function MapPositionListener(cb) {
  return ({ latLng }) => {
    const latitude = latLng.lat();
    const longitude = latLng.lng();
    cb({ latitude, longitude });
  };
}

export default MapPositionListener;
